import React, { useEffect } from 'react';
import { Box, Typography, Avatar, Badge } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { StyledAppBar, StyledContainer, HeaderBox, NotificationIconButton, UserBox, AvatarWrapper, UserInfoBox, UserNameTypography, UserRoleTypography } from './styles/CustomUserHeader.styles';
import { useAuth } from '../hooks/useAuth';
import { getUserName, getUserRoleName } from '../utils/helpers';
import { AppDispatch, RootState } from '../stores';
import { fetchNotificationCount } from '../stores/notificationSlice';
import NotificationModal from './UI/NotificationListModal';

const CustomerHeader: React.FC = () => {
  const user = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const count = useSelector((state: RootState) => state.notifications.count);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const notificationClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  useEffect(() => {
    dispatch(fetchNotificationCount());
  }, [dispatch]);

  return (
    <StyledAppBar position="static" elevation={0}>
      <StyledContainer maxWidth={false} disableGutters>
        <HeaderBox>
          <Typography component="span" sx={{ color: '#000', fontSize: 18, lineHeight: '22px', fontWeight: 500 }}>
            Hi, {getUserName(user) || 'Customer'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <NotificationIconButton className="yellow">
              <img src="/images/email-icon.svg" alt="Msg" />
            </NotificationIconButton>

            <NotificationIconButton onClick={notificationClick}>
              <Badge badgeContent={count} color="primary">
                <img src="/images/notification-icon2.svg" alt="bell" />
              </Badge>
            </NotificationIconButton>

            <NotificationModal onClose={handleClose} anchorEl={anchorEl} />
            <UserBox sx={{ cursor: 'pointer' }}>
              <AvatarWrapper>
                <Avatar
                  alt={getUserName(user) || "User"}
                  src={"/images/static/user-photo.png"}
                  sx={{ width: 38, height: 38 }}
                />
              </AvatarWrapper>
              <UserInfoBox>
                <UserNameTypography>{getUserName(user) || 'Guest'}</UserNameTypography>
                <UserRoleTypography>{getUserRoleName(user)}</UserRoleTypography>
              </UserInfoBox>
            </UserBox>
          </Box>
        </HeaderBox>
      </StyledContainer>
    </StyledAppBar>
  );
};

export default CustomerHeader;
